export enum CurrencyEnum {
  EGP = "EGP",
  // USD = "USD",
  // EUR = "EUR",
  // GBP = "GBP",
}

export const currencyList = Object.values(CurrencyEnum);
